import React from 'react';
import './contacts.css';

import { useState, useEffect } from 'react';
import Axios from 'axios';
import { getDocumentmgmtServiceURLuser } from '../../config/connections';
import { USBGrid, USBColumn, USBBreadcrumb, USBButton } from '@usb-shield/components-react/dist/cjs';
import { USBInput } from '../../components/shared/USBInputCompat';
import { USBIconCopy, USBIconEnvelope } from '@usb-shield/react-icons';
import { endpoints } from '../../../config/connections';
import Loader from '../../components/utilities/Loader';
import AutoCompleteDropdown from '../../components/shared/AutoCompleteDropdown/AutoCompleteDropdown';
import { USBIconDocuments2 } from '@usb-shield/react-icons/dist/cjs';

const Contacts = () => {

    const [clearFilterClicked, setClearFilterClicked] = useState(false);
    const [contactsAndDeals, setContactsAndDeals] = useState([]);
    const [filteredContactsAndDeals, setFilteredContactsAndDeals] = useState([]);
    const [allPermissions, setAllPermissions] = useState({
        deals: [],
        categories: []
    });
    const [contactsAsPerOffset, setContactsAsPerOffset] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [sortBy, setSortBy] = useState('deal');
    const [sortOrder, setSortOrder] = useState('asc');
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const [searchedDeal, setSearchedDeal] = useState({ key: null, value: null });

    useEffect(() => {
        getAssignedPermission();

    }, []);

    useEffect(() => {
        initialRender()
        setTotalPages(Math.ceil(allPermissions.deals.length / pageSize));
    }, [allPermissions, currentPage, pageSize])

    const formatCategories = (categories) => {
        if (categories && categories.length > 0) {
            return categories.map(category => {
                if(category.key.includes('-')){
                    return {key : category.key.split('-')[0].trim(), value : category.value}
                }
                else{
                    return category;
                }
            });
        }
    }

    const initialRender = () => {
        if (allPermissions.deals.length > 0 || allPermissions.categories.length > 0) {
            const prevResponse = contactsAsPerOffset.find(item => item.pageSize === pageSize && item.currentPage === currentPage);
            if (prevResponse) {
                setContactsAndDeals(prevResponse.contactsAndDeals);
                setFilteredContactsAndDeals(prevResponse.contactsAndDeals);
            } else {
                fetchDealLeads({ deals: allPermissions.deals.slice((currentPage - 1) * pageSize, currentPage * pageSize), categories: formatCategories(allPermissions.categories) });
            }
        }
    }

    const getSortedData = (dealsOrContacts) => {
        if (!dealsOrContacts) return [];
        return [...dealsOrContacts].sort((a, b) => {
            let aVal = sortBy == 'deal' ? a.value : a.bankerEmailId;
            let bVal = sortBy == 'deal' ? b.value : b.bankerEmailId;
            if (aVal != undefined && aVal !== null && bVal != undefined && bVal !== null) {
                if (aVal < bVal) return sortOrder === 'asc' ? -1 : 1;
                if (aVal > bVal) return sortOrder === 'asc' ? 1 : -1;
                return 0;
            }
        });
    };

    const getAssignedPermission = () => {
        setLoading(true);
        const config = {
            cdcType: "docmanagement",
            headers: {
                'jwt': `${sessionStorage.getItem('tok')}`,
                'user-id': sessionStorage.getItem('remote_user') ? JSON.parse(sessionStorage.getItem('remote_user')).userID : JSON.parse(sessionStorage.getItem('userData')).userId
            }
        }
        let currentAsignedUrl = getDocumentmgmtServiceURLuser({
            service: 'getProfilePermissionsforUser',
            userid: sessionStorage.getItem('remote_user') ? JSON.parse(sessionStorage.getItem('remote_user')).userID : JSON.parse(sessionStorage.getItem('userData')).userId
        });
        currentAsignedUrl = currentAsignedUrl + "?role=" + (sessionStorage.getItem('remote_user') ? JSON.parse(sessionStorage.getItem('remote_user')).profileRole : JSON.parse(sessionStorage.getItem('userData')).role);
        Axios.get(currentAsignedUrl, config).then(response => {
            let permissions = {
                deals: [],
                categories: []
            }
            if (response.data.length > 1) {
                response.data.forEach(entry => {
                    if (entry.deals && entry.deals.length > 0) {
                        permissions.deals.push(...entry.deals);
                    }
                    if (entry.categories && entry.categories.length > 0) {
                        permissions.categories.push(...entry.categories);
                    }
                });
            } else {
                response.data.forEach(entry => {
                    if (entry.deals && entry.deals.length > 0) {
                        permissions.deals.push(...entry.deals);
                    }
                    if (entry.categories && entry.categories.length > 0) {
                        permissions.categories.push(...entry.categories);
                    }
                });
            }
            permissions.deals = Array.from(
                new Map(permissions.deals.map(deal => [JSON.stringify(deal), deal])).values()
            );
            const sortedDeals = getSortedData(permissions.deals).filter(deal => deal && deal.value !== undefined && deal.value !== null && deal.value !== '' && deal.key !== undefined && deal.key !== null && deal.key !== '');
            setAllPermissions({ categories: permissions.categories, deals: sortedDeals });
        }).catch(error => {
            setLoading(false);
            console.error("There is an error while fetching User Permissions.", error);
        })
    }

    const fetchDealLeads = (entitlements, isDealSelected = false) => {
        setLoading(true);
        const uniqueCategories = Array.from(
            new Map(
                entitlements.categories.map(item => [JSON.stringify(item), item])
            ).values()
        );
        const payload = searchedDeal.key == null ? {
            categories: uniqueCategories,
            deals: entitlements.deals
        } : {
            categories: uniqueCategories,
            deals: [searchedDeal]
        };
        const url = `${endpoints.apigee}/document-management/coreservice/user-management/v1/users/deals/contacts`;
        Axios.post(url, payload, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Client-Application': 'CDC',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'user-id': sessionStorage.getItem('remote_user') ? JSON.parse(sessionStorage.getItem('remote_user')).userID : JSON.parse(sessionStorage.getItem('userData')).userId,
                'jwt': `${sessionStorage.getItem('tok')}`,
                'Accept': 'application/json',
                'Correlation-ID': `${sessionStorage.getItem('loggedUser')} ${sessionStorage.getItem('correlationId')}`
            }
        }).then(response => {
            setContactsAndDeals(response.data.deals);
            setFilteredContactsAndDeals(response.data.deals);
            if (!isDealSelected) {
                setContactsAsPerOffset((prev) => [...prev, { contactsAndDeals: response.data.deals, pageSize: pageSize, currentPage: currentPage }]);
            }
            setLoading(false);
        }).catch(error => {
            setLoading(false);
            console.error("Error fetching deal leads:", error);
        });

    }

    const onDealSelect = (e) => {
        setSearchedDeal({ key: e.key, value: e.value });
        fetchDealLeads({ deals: [{ key: e.key, value: e.value }], categories: allPermissions.categories }, true);
        setTotalPages(Math.ceil(1 / pageSize));
    }

    const formatBankerNameToTitleCase = (name) => {
        if (name !== null && name !== undefined) {
            if (name.includes(',')) {
                return name
                    .split(/[,]+/)
                    .filter(word => word.length > 0)
                    .map(word => word.trim().charAt(0).toUpperCase() + word.trim().slice(1).toLowerCase())
                    .reverse()
                    .join(' ');
            } else {
                return name
                    .split(/[\s]+/)
                    .filter(word => word.length > 0)
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                    .join(' ');
            }
        } else {
            return '-'
        }
    }

    const handleSort = (column) => {
        if (sortBy === column) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortBy(column);
            setSortOrder('asc');
        }
    };

    const sortedData = getSortedData(filteredContactsAndDeals);

    useEffect(() => {
        setCurrentPage(1);
    }, [pageSize]);

    return (
        <>
            {loading ? <Loader /> : null}
            <USBGrid addClasses="content-frame">
                <USBColumn largeSpan={16}>
                    {sessionStorage.getItem('remote_user') ? (
                        <div className="warning-panel-remote">
                            You are impersonating the user:{' '}
                            {JSON.parse(sessionStorage.getItem('remote_user')).firstName}{' '}
                            {JSON.parse(sessionStorage.getItem('remote_user')).lastName}. To
                            exit, click the 'Exit User' link above.
                        </div>
                    ) : (
                        ''
                    )}
                </USBColumn>
            </USBGrid>

            <USBGrid addClasses="content-frame ">
                <USBColumn largeSpan={16}>
                    <h1 className="heading-h1 grid-margins">
                        Contacts
                    </h1>
                </USBColumn>
            </USBGrid>

            <USBGrid addClasses="content-frame ">
                <USBColumn largeSpan={32}>
                </USBColumn>
            </USBGrid>

            <div className="contacts-table-container">
                {allPermissions.deals && allPermissions.deals.length > 0 && <div className='contacts-filter-container'>
                    <div className='contacts-dealID-filter'>
                        <AutoCompleteDropdown
                            key={clearFilterClicked + ''}
                            onItemSelect={(e) => onDealSelect(e)}
                            comboboxId="combobox"
                            autocompleteInputId="autocomplete-input"
                            listboxID="listbox"
                            arrowId="combobox-arrow"
                            listItems={allPermissions.deals.map(deal => { return { ...deal, term: deal.value } })}
                            label="Deal ID"
                        />
                    </div>
                    <div className="contacts-clear-filter">
                        <USBButton
                            id="clearfiltercontacts"
                            name="clearfiltercontacts"
                            variant="utility"
                            className="clear-filter-contacts"
                            handleClick={() => {
                                setClearFilterClicked(prev => !prev);
                                setSearchedDeal({ key: null, value: null });
                                setTotalPages(Math.ceil(allPermissions.deals.length / pageSize));
                                initialRender()
                            }}
                        >
                            Clear filters
                        </USBButton>
                    </div>
                </div>}

                {allPermissions.deals && allPermissions.deals.length > 0 && <div className='contacts-pagination-container'>

                    {/* Pagination Controls */}
                    <div className="contacts-pagination" style={{ marginTop: 16, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8 }}>
                        <button
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                        >
                            Prev
                        </button>
                        <span>
                            Page {currentPage} of {totalPages}
                        </span>
                        <button
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                        >
                            Next
                        </button>
                    </div>
                    <div className='pagination-controls-container'>
                        {!searchedDeal.key && <label>
                            <span className='pagination-page-size'>Items per page:</span>&nbsp;
                            <select
                                className='pagination-page-size-dropdown'
                                value={pageSize}
                                onChange={e => {
                                    setPageSize(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                            >
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </label>}
                    </div>
                </div>}
                {filteredContactsAndDeals.length > 0 ?
                    <>
                        <table className="contacts-table">
                            <thead>
                                <tr>
                                    <th>
                                        <button
                                            type="button"
                                            className="contacts-table-sort-btn"
                                            onClick={() => handleSort('deal')}
                                        >
                                            Deal {sortBy === 'deal' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                    </th>
                                    <th>
                                        <button
                                            type="button"
                                            className="contacts-table-sort-btn"
                                            onClick={() => handleSort('contact')}
                                        >
                                            Contact Information {sortBy === 'contact' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                    </th>
                                    <th>
                                        <button className='contacts-table-sort-btn' onClick={null}>
                                            Actions
                                        </button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedData && sortedData.length > 0 ? (
                                    sortedData.map((item, idx) => {
                                        // If item contains '|', split into entity and contact, else show as entity only
                                        return (
                                            <tr key={idx}>
                                                <td>{item.value}</td>
                                                <td>
                                                    <div>
                                                        <div>{item.bankerEmailId}</div>
                                                        <div>{formatBankerNameToTitleCase(item.userName)}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'left' }}>
                                                        {/* Copy to clipboard */}
                                                        <div title='Copy Email'>
                                                            <USBButton
                                                                addClasses={'no-border-icon-button'}
                                                                variant={'secondary'}
                                                                type="button"
                                                                size={'small'}
                                                                title="Copy Email"
                                                                ariaLabel="Copy Email"
                                                                handleClick={() => {
                                                                    navigator.clipboard.writeText(item.bankerEmailId);
                                                                }}
                                                            >
                                                                <USBIconCopy title={"Copy Email"} size={24} colorVariant={'brand-primary'}></USBIconCopy>
                                                            </USBButton>
                                                        </div>
                                                        {/* Open Outlook */}
                                                        <div title='Send Email'>
                                                            <USBButton
                                                                addClasses={'no-border-icon-button'}
                                                                variant={'secondary'}
                                                                size={'small'}
                                                                type="button"
                                                                title="Send Email"
                                                                handleClick={() => {
                                                                    window.location.href = `mailto:${item.bankerEmailId}`;
                                                                }}
                                                            >
                                                                <USBIconEnvelope title={"Send Email"} size={24} colorVariant={'brand-primary'}></USBIconEnvelope>
                                                            </USBButton>
                                                        </div>
                                                        {/* Open Teams Chat
                                                // <button
                                                //     type="button"
                                                //     title="Open Teams Chat"
                                                //     onClick={() => {
                                                //         window.open(`https://teams.microsoft.com/l/chat/0/0?users=test@usbank.com`, '_blank');
                                                //     }}
                                                // >
                                                //     💬
                                                // </button> */}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td><div style={{
                                            textAlign: 'center', fontWeight: 'bold', width: '100%',
                                            border: '1px solid black',
                                            borderRadius: '8px',
                                            padding: '8px'
                                        }}>No contacts to display</div></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {/* Pagination Controls */}
                        <div className="contacts-pagination" style={{ marginTop: 16, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8 }}>
                            <button
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                            >
                                Prev
                            </button>
                            <span>
                                Page {currentPage} of {totalPages}
                            </span>
                            <button
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                            >
                                Next
                            </button>
                        </div>
                    </>
                    : loading ? '' : <div style={{
                        textAlign: 'center', fontWeight: 'bold', width: '100%',
                        border: '1px solid black',
                        borderRadius: '8px',
                        padding: '8px'
                    }}>No contacts to display</div>}
            </div>
        </>
    )
}

export default Contacts;